export const GET_CD_COWS_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_CD_COWS_REQUEST";
export const GET_CD_COWS_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_CD_COWS_SUCCESS";
export const GET_CD_COWS_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_CD_COWS_FAILURE";

export const GET_CD_SELECTEDCOW_DATA_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_CD_SELECTEDCOW_DATA_REQUEST";
export const GET_CD_SELECTEDCOW_DATA_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_CD_SELECTEDCOW_DATA_SUCCESS";
export const GET_CD_SELECTEDCOW_DATA_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_CD_SELECTEDCOW_DATA_FAILURE";
